<div class="block--content block" id="main-content">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>
        <div class="ticket">
            <h1 class="page-title text-xl">{{ 'TERMS_CONDITIONS_TITLE' | translate }}</h1>
            <iframe
                class="tnc__iframe"
                *ngIf="termsUrl"
                [src]="termsUrl"
                title="{{ 'TERMS_CONDITIONS_TITLE' | translate }}">
            </iframe>
        </div>
    </div>
</div>
